import {TheCryptGameConfig} from "../TheCryptGameConfig";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {TheCrypt} from "../TheCrypt";
import {BitmapText} from "pixi.js";
import {TheCryptGameAssets} from "../TheCryptGameAssets";

export class Ways extends PIXI.Container {
    private _ways: BitmapText;
    private _animation: TimelineSprite;

    constructor() {
        super();
        this.name = "Ways";
        this._ways = new BitmapText(TheCryptGameConfig.DEFAULT_WAYS.toString(), {
            fontName: TheCryptGameAssets.BITMAP_FONT_WIN_WAYS,
            fontSize: 20,
            tint: 0xffffff
        });
        this._ways.anchor = new PIXI.Point(1, 0);
        this._ways.letterSpacing = -12;
        this._animation = new TimelineSprite(TheCrypt.assetLoader.getTextures("gemAdd"));
        this._animation.hide();
        this.addChild(this._animation);
        this.addChild(this._ways);
        this.updatePosition();
        this._animation.blendMode = PIXI.BLEND_MODES.ADD;
        this._animation.scale.set(2);
        this._animation.anchor.set(0.5, 0);
    }

    public updatePosition(): void {
        this._ways.position.set(350, 0);
        this._animation.position.set(350-this._ways.width * 0.5, -84);
    }

    public updateValue(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this._animation.getAnimationAutoShowHide(true, true));
        tl.add(() => {
            this._ways.text = value.toString();
            this.updatePosition();
        }, 0.3);
        return tl;
    }

    public reset(): void {
        this._ways.text = TheCryptGameConfig.DEFAULT_WAYS.toString();
        this.updatePosition();
    }

    get value(): number {
        return parseInt(this._ways.text);
    }

    get textWidth(): number {
        return this._ways.width;
    }

    get textHeight(): number {
        return this._ways.height;
    }
}